/**
 * DevExtreme (esm/__internal/scheduler/utils/is_agenda_workpace_component.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const workspaceAgendaComponentName = "dxSchedulerAgenda";
export function isAgendaWorkspaceComponent(component) {
  return "dxSchedulerAgenda" === component.NAME;
}